import { Modal } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { useCallback } from 'react';
import { useCampaignEditorContext } from '../../contexts/CampaignEditorContext';
import { useConfirmUnsavedChangesModal } from '../../tabs/CampaignWorkflowTab/contexts';
import { useSaveWorkflow } from '../../hooks/useSaveWorkflow';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface YouHaveUnsavedChangesModalProps {}

export const ModalContainer = styled.div`
  display: block;
`;

export const YouHaveUnsavedChangesModal = (props: YouHaveUnsavedChangesModalProps) => {
  const { t } = useTranslation('campaigns');
  const { dispatch } = useCampaignEditorContext();
  const saveWorkflow = useSaveWorkflow();
  const {
    confirmUnsavedChangesModalOpen,
    nextAction,
    closeConfirmUnsavedChangesModal,
  } = useConfirmUnsavedChangesModal();

  const onDiscardChanges = useCallback(() => {
    dispatch({ type: 'MOVE_AND_REVERT_CHANGES' });
    nextAction();
    closeConfirmUnsavedChangesModal();
  }, [closeConfirmUnsavedChangesModal, dispatch, nextAction]);

  const onSaveChanges = useCallback(() => {
    saveWorkflow();
    nextAction();
    closeConfirmUnsavedChangesModal();
  }, [closeConfirmUnsavedChangesModal, nextAction, saveWorkflow]);

  return (
    <Modal
      minWidth={570}
      heading={t('onsite.editor.workflow.youHaveUnsavedChangesModal.heading')}
      isOpen={confirmUnsavedChangesModalOpen}
      variation="clean"
      onCloseButtonClicked={closeConfirmUnsavedChangesModal}
      // We need to swap the confirm/cancel as we want the primary button to be on the left hand side
      // of the modal
      onCancelButtonClicked={onSaveChanges}
      cancelButtonLabel={t('onsite.editor.workflow.youHaveUnsavedChangesModal.confirmButton')}
      cancelButtonAriaLabel={t('onsite.editor.workflow.youHaveUnsavedChangesModal.confirmButton')}
      cancelButtonType="primary"
      onOkButtonClicked={onDiscardChanges}
      okButtonLabel={t('onsite.editor.workflow.youHaveUnsavedChangesModal.closeButton')}
      okButtonAriaLabel={t('onsite.editor.workflow.youHaveUnsavedChangesModal.closeButton')}
      okButtonType="secondary"
    >
      <ModalContainer>
        <div>{t('onsite.editor.workflow.youHaveUnsavedChangesModal.body')}</div>
      </ModalContainer>
    </Modal>
  );
};
